import { Extension, CommandProps } from "@tiptap/core";
import { Plugin, PluginKey } from "@tiptap/pm/state";

export const VariableInsertCommand = Extension.create({
  name: "variableInsertCommand",

  addCommands() {
    return {
      insertVariable:
        () =>
        ({ state, chain }: CommandProps ) => {
          const selection = state.selection;
          const hasSelection = selection && selection.from !== selection.to;

          if ( hasSelection ) {
            return chain().focus().setMark("variable").run();
          } else {
            const pos = state.selection.from ?? 0;
            const variableText = "nomeDaVariavel";
            const endPos = pos + variableText.length;

            return chain()
              .focus()
              .insertContent({
                type: "text",
                text: variableText,
                marks: [
                  {
                    type: "variable",
                  },
                ],
              })
              .setTextSelection({ from: pos, to: endPos })
              .run();
          }
        },
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("variableInputValidation"),
        props: {
          handleTextInput: ( view, from, to, text ) => {
            const { state } = view;

            const marksAtPos = state.storedMarks ?? state.doc.resolve( from ).marks();
            const isInsideVariable = marksAtPos.some( mark => mark.type.name === "variable");

            if (isInsideVariable) {
              const isValid = /^[a-zA-Z0-9]+$/.test( text );

              if (!isValid) return true;
            }

            return false;
          },
        },
      }),
    ]
  },
})
